export const ATRIBUTO_MODO = 'data-teclado-modo'

const CAMPOS = 'input, textarea'

export function calarCampo(el: Element): void {
  if (el.getAttribute('inputmode') === 'none') return

  el.setAttribute(ATRIBUTO_MODO, el.getAttribute('inputmode') ?? '')
  el.setAttribute('inputmode', 'none')
}

export function calarTecladoDoSistema(raiz: ParentNode = document): void {
  for (const el of raiz.querySelectorAll(CAMPOS)) calarCampo(el);
}

export function vigiarTecladoDoSistema(alvo: Node = document.body): () => void {
  calarTecladoDoSistema(alvo as unknown as ParentNode)

  if (typeof MutationObserver === 'undefined') return () => undefined

  const observador = new MutationObserver((mutacoes) => {
    for (const mutacao of mutacoes) {
      if (mutacao.type === 'attributes') {
        if (mutacao.target instanceof Element) calarCampo(mutacao.target)
        continue
      }

      for (const no of mutacao.addedNodes) {
        if (!(no instanceof Element)) continue
        if (no.matches(CAMPOS)) calarCampo(no)
        calarTecladoDoSistema(no)
      }
    }
  })

  observador.observe(alvo, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['inputmode'],
  })

  return () => observador.disconnect()
}
